var $92891233a800d8f5$exports = {};
$92891233a800d8f5$exports = {
    "showAllButtonLabel": (args, formatter)=>`Show all (${formatter.number(args.tagCount)})`,
    "hideButtonLabel": `Show less`,
    "actions": `Actions`,
    "noTags": `None`
};


export {$92891233a800d8f5$exports as default};
//# sourceMappingURL=en-US.mjs.map
